export default __webpack_public_path__ + "static/media/logo-secundario.57aa2ed1.png";